export interface Manifest {
	series: ManifestSeries[];
}

export interface ManifestSeries {
	key: string;
	title: string;
	shortTitle: string;
	episodes: ManifestEpisode[];
}

export interface ManifestEpisode {
	id: number;
	title: string;
	shortTitle: string;
}

export interface ManifestEntry {
	key: string;
	descriptions: string[];
	tags: string[];
}